import styled, { css } from 'styled-components'

export const NewsListWrap = styled.div`

`
